import Vue from 'vue'

// Framework
import AppHeader from './framework/Header'
import HeaderButton from './framework/HeaderButton'
import AppNavigation from './framework/Navigation'
import NavItem from './framework/NavItem'
import AppChat from './framework/Chat'
import ChatInterface from './framework/ChatInterface'
import ChatModal from './framework/ChatModal'

// Forms
import BSForm from './forms/BSForm'
import BSMultiStep from './elements/BSMultiStep'
import Step from './elements/Step'
import InputField from './forms/InputField'
import CheckboxField from './forms/CheckboxField'
import SelectField from './forms/SelectField'
import ToggleField from './forms/ToggleField'
import FileField from './forms/FileField'
import RadioSlider from './forms/RadioSlider'
import TextField from './forms/TextField'
import Datepicker from 'vuejs-datepicker'
import BSDate from './forms/BSDate'
import CommentField from './forms/CommentField'
import BadgeSelect from './forms/BadgeSelect'

// Wizards

// Elements
import RouteHeader from './elements/RouteHeader'
import RouteNavigation from './elements/RouteNavigation'
import Avatar from './elements/Avatar'
import BSButton from './elements/BSButton'
import BSAction from './elements/BSAction'
import BSBadge from './elements/BSBadge'
import BSCard from './elements/BSCard'
import BSTable from './elements/BSTable'
import BSTableHead from './elements/BSTableHead'
import BSButtonSort from './elements/BSButtonSort'
import BSAlert from './elements/BSAlert'
import BSModal from './elements/BSModal'
import Pagination from './elements/Pagination'
import KeywordMovement from './elements/KeywordMovement'
import Loading from './elements/Loading'
import APIQueue from './elements/APIQueue'
import ChunkProcess from './elements/ChunkProcess'
import CardLegend from './elements/CardLegend'

// Content
import NavSecondarySettings from './content/NavSecondarySettings'
import Users from './content/Users'
import Roles from './content/Roles'
import Feeds from './content/Feeds'
import Budgets from './content/Budgets'
import Funds from './content/Funds'
import Tags from './content/Tags'
import BankFeeds from './content/BankFeeds'
import Transactions from './content/Transactions'
import BudgetChart from './content/BudgetChart'
import FundBalances from './content/FundBalances'
import BudgetBalances from './content/BudgetBalances'

Vue.component('app-header', AppHeader)
Vue.component('header-button', HeaderButton)
Vue.component('app-navigation', AppNavigation)
Vue.component('nav-item', NavItem)
Vue.component('app-chat', AppChat)
Vue.component('chat-interface', ChatInterface)
Vue.component('chat-modal', ChatModal)

Vue.component('bs-form', BSForm)
Vue.component('bs-multi-step', BSMultiStep)
Vue.component('step', Step)
Vue.component('input-field', InputField)
Vue.component('checkbox-field', CheckboxField)
Vue.component('select-field', SelectField)
Vue.component('toggle-field', ToggleField)
Vue.component('file-field', FileField)
Vue.component('radio-slider', RadioSlider)
Vue.component('text-field', TextField)
Vue.component('datepicker', Datepicker)
Vue.component('date-field', BSDate)
Vue.component('comment-field', CommentField)
Vue.component('badge-select', BadgeSelect)

Vue.component('route-header', RouteHeader)
Vue.component('route-navigation', RouteNavigation)
Vue.component('avatar', Avatar)
Vue.component('bs-button', BSButton)
Vue.component('bs-action', BSAction)
Vue.component('bs-badge', BSBadge)
Vue.component('bs-card', BSCard)
Vue.component('bs-table', BSTable)
Vue.component('bs-th', BSTableHead)
Vue.component('bs-btn-sort', BSButtonSort)
Vue.component('bs-alert', BSAlert)
Vue.component('bs-modal', BSModal)
Vue.component('pagination', Pagination)
Vue.component('keyword-movement', KeywordMovement)
Vue.component('loading', Loading)
Vue.component('queue', APIQueue)
Vue.component('chunk-process', ChunkProcess)
Vue.component('card-legend', CardLegend)

Vue.component('nav-secondary-settings', NavSecondarySettings)
Vue.component('users', Users)
Vue.component('roles', Roles)
Vue.component('feeds', Feeds)
Vue.component('tags', Tags)
Vue.component('budgets', Budgets)
Vue.component('funds', Funds)
Vue.component('bank-feeds', BankFeeds)
Vue.component('transactions', Transactions)
Vue.component('budget-chart', BudgetChart)
Vue.component('fund-balances', FundBalances)
Vue.component('budget-balances', BudgetBalances)
